const valuesLabelMap = {
  min_km: { pre: 'Acima de ', pos: 'km' },
  max_km: { pre: 'Até ', pos: 'km' },
  min_model_year: { pre: 'Após ', pos: '' },
  max_model_year: { pre: 'Até ', pos: '' },
  min_price: { pre: 'Acima de R$ ', pos: '' },
  max_price: { pre: 'Até R$ ', pos: '' }
};

const parseUnitValues = (key, unitValues, unitsOptions) => {
  if (unitsOptions && unitsOptions.length > 0) {
    const parsedUnits = unitValues.reduce((unitsAcc, unit) => {
      const unitData = unitsOptions.find(unitOption => unitOption.value == unit)
      if (!unitData) return unitsAcc

      return [...unitsAcc, { key, value: unitData.title, originalValue: unit }]
    }, [])

    return parsedUnits
  }

  return []
}

const removeLeadingZeros = (text) => {
  return text.replace(/\b0+(\d+)\b/g, (match, number) => {
    return number;
  });
}

export const addThousandSeparator = (textValue) => {
  if (!textValue) return textValue

  const parsedText = textValue.toString()
  const textFormated = removeLeadingZeros(parsedText)

  return textFormated.replace(/\d+/g, (match) => {
    return match.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  });
}

const createFilterPill = (key, value, labelMap) => {
  const parsedValue = labelMap ? `${labelMap.pre}${value}${labelMap.pos}` : value;

  if (['min_price', 'max_price', 'min_km', 'max_km'].includes(key)) {
    return { key, value: addThousandSeparator(parsedValue), originalValue: value };
  }
  
  return { key, value: parsedValue, originalValue: value };
};

export const makeFiltersPillData = (filtersList, unitsOptions) => {
  const filtersPillsData = Object.keys(filtersList).reduce((pillsData, key) => {
    if (['sort'].includes(key)) return pillsData;

    if(key === 'units') {
      const parsedUnitsPills = parseUnitValues(key, filtersList[key], unitsOptions)

      return [...pillsData, ...parsedUnitsPills];
    }
  
    const currentFilter = filtersList[key];
    if (!currentFilter) return pillsData;
  
    const labelMap = valuesLabelMap[key];
  
    if (!Array.isArray(currentFilter)) {
      return [...pillsData, createFilterPill(key, currentFilter, labelMap)];
    }
  
    const filterPills = currentFilter.map(value => createFilterPill(key, value, labelMap));
    return [...pillsData, ...filterPills];
  }, []);

  return filtersPillsData;
}
